module.exports = __webpack_public_path__ + "static/9i-28f9151055c950874d2c6803a39b425b.woff";